var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pbi-report',{ref:"dashboard",attrs:{"height":"100vh","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }